import auth from "../auth/actions.js";

export default {
  async GetUsers(context, payload) {
    // SetHeaders(context);
    var params =
      "type=" +
      payload.type +
      "&status=" +
      payload.status +
      "&valid=" +
      payload.valid +
      "&offset=" +
      payload.offset +
      "&limit=" +
      payload.offset;

    const response = await auth.middleware.get("/GetUsers?" + params, {
      headers: { request: "GetUsers" },
    });

    const responseData = response.data;
    if (response.status !== 200) {
      //
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    //
    if (responseData.success) {
      context.commit("setUsers", {
        users: responseData.result.users,
        count: responseData.result.count,
        pageLimit: responseData.result.pageLimit,
      });
    }

    return { success: responseData.success, message: responseData.message };
  },
  async GetUsersStats() {
    // SetHeaders(context);
    const response = await auth.middleware.get("/GetUsersStats", {
      headers: { request: "GetUsersStats" },
    });

    const responseData = response.data;
    if (response.status !== 200) {
      //
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    return {
      success: responseData.success,
      message: responseData.message,
      result: responseData.result,
    };
  },
  async GetUserInfo(context, payload) {
    // SetHeaders(context);
    const response = await auth.middleware.get(
      "/GetUserInfo?userid=" + payload,
      {
        headers: { request: "GetUserInfo" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      //
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    if (responseData.success) {
      context.commit("setUserInfo", {
        userInfo: responseData.result,
      });
    }

    return {
      success: responseData.success,
      message: responseData.message,
      result: responseData.result
    };
  },
  async EditUserInfo(context, payload) {
    const body = {
      fullname: payload.fullname,
      phone: payload.phone,
      email: payload.email,
      username: payload.username,
    };
    const response = await auth.middleware.post(
      "/UpdateUserInfo",
      JSON.stringify(body),
      {
        headers: { request: "UpdateUserInfo" },
      }
    );

    const responseData = response.data;
    if (response.status != 200) {
      //
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    if (responseData.success) {
      context.commit("setUserInfoProfile", body);
    }

    return { success: responseData.success, message: responseData.message };
  },

  async ResetUserPassword(_, payload) {
    const body = {
      newpassword: payload.newpassword,
      username: payload.username,
    };
    const response = await auth.middleware.post(
      "/ResetUserPassword",
      JSON.stringify(body),
      {
        headers: { request: "ResetUserPassword" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      //
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    return { success: responseData.success, message: responseData.message };
  },
  async ChangeUserType(context, payload) {
    const body = {
      type: payload.type,
      username: payload.username,
    };
    const response = await auth.middleware.post(
      "/ChangeUserType",
      JSON.stringify(body),
      {
        headers: { request: "ChangeUserType" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      //
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    if (responseData.success) {
      context.commit("setUserInfoType", payload.type);
    }

    return { success: responseData.success, message: responseData.message };
  },

  async ChangeUserSkills(context, payload) {
    const body = {
      skills: payload.skills,
      username: payload.username,
    };
    const response = await auth.middleware.post(
      "/ChangeUserSkills",
      JSON.stringify(body),
      {
        headers: { request: "ChangeUserSkills" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    if (responseData.success && !payload.fromSkill) {
      context.commit("setUserInfoSkills", responseData.result.skills);
    }

    return { success: responseData.success, message: responseData.message };
  },
  async GetDialoutNumber(context, payload) {
    const response = await auth.middleware.get(
      "/GetUserDialOutNumber?username=" + payload,
      {
        headers: { request: "GetUserDialOutNumber" },
      }
    );
    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    if (responseData.success) {
      context.commit("setDialOutNum", responseData.result.callerID);
    }

    return { success: responseData.success, message: responseData.message };
  },
  //GetDomainSkills
  async GetDomainSkills(context) {
    const response = await auth.middleware.get("/GetDomainSkills", {
      headers: { request: "GetDomainSkills" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    //
    if (responseData.success) {
      context.commit("setDomainSkills", responseData.result.skills);
    }

    return { success: responseData.success, message: responseData.message };
  },

  //SettUserDialOutNumber
  async SetUserCallerID(context, payload) {
    const body = {
      callerID: payload.callerID,
      process: payload.process,
      username: payload.username,
    };
    const response = await auth.middleware.post(
      "/SetUserDialOutNumber",
      JSON.stringify(body),
      {
        headers: { request: "SetUserDialOutNumber" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    if (responseData.success) {
      context.commit("setDialOutNum", payload.callerID);
    }

    return { success: responseData.success, message: responseData.message };
  },
  async SetUserForwarding(context, payload) {
    const body = {
      forward: payload.forward,
      username: payload.username,
      workPhone: payload.workPhone,
    };
    const response = await auth.middleware.post(
      "/SetUserForwarding",
      JSON.stringify(body),
      {
        headers: { request: "SetUserForwarding" },
      }
    );

    const responseData = await response.data;
    if (response.status != 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },

  async GetUserLoginStatus(context, payload) {
    const response = await auth.middleware.get(
      "/GetUserLoginStatus?username=" + payload,
      {
        headers: { request: "GetUserLoginStatus" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    //
    if (responseData.success) {
      context.commit("setUserLoginStatus", responseData.result);
    }

    return { success: responseData.success, message: responseData.message };
  },
  //LogoutUser
  async LogoutUser(context, payload) {
    const body = {
      uname: payload,
    };
    const response = await auth.middleware.post(
      "/LogoutUser",
      JSON.stringify(body),
      {
        headers: { request: "LogoutUser" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    if (responseData.success) {
      // console.log("My respnse data:", responseData.result);
      context.commit("setUserLoginStatus", responseData.result);
      context.commit("setUserStatus", 4);
    }

    return { success: responseData.success, message: responseData.message };
  },
  async LoginUser(context, payload) {
    const body = {
      username: payload,
    };
    const response = await auth.middleware.post(
      "/LoginUser",
      JSON.stringify(body),
      {
        headers: { request: "LoginUser" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    if (responseData.success) {
      context.commit("setUserLoginStatus", responseData.result);
      context.commit("setUserStatus", 1);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetDomainUsers(context) {
    const response = await auth.middleware.get("/GetDomainUsers", {
      headers: { request: "GetDomainUsers" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    //
    if (responseData.success) {
      context.commit("setDomainUsers", responseData.result.usernames);
    }

    return { success: responseData.success, message: responseData.message };
  },
  async GetDomainRanges(context) {
    const response = await auth.middleware.get("/GetDomainRanges", {
      headers: { request: "GetDomainRanges" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    //
    if (responseData.success) {
      context.commit("setDomainRanges", responseData.result.ranges);
    }

    return { success: responseData.success, message: responseData.message };
  },

  async CreateNewUser(context, payload) {
    const body = {
      username: payload.username,
      fullname: payload.fullname,
      phone: payload.phone,
      email: payload.email,
      type: payload.type,
      password: payload.password,
      expireable: payload.expireable,
      expiredate: payload.expiredate,
      startdate: payload.startdate,
      skills: payload.skills,
      domain: payload.domain,
    };
    const response = await auth.middleware.post(
      "/CreateNewUser",
      JSON.stringify(body),
      {
        headers: { request: "CreateNewUser" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    return { success: responseData.success, message: responseData.message };
  },

  async RecycleUser(context, payload) {
    const body = {
      username: payload.username,
      fullname: payload.fullname,
      phone: payload.phone,
      email: payload.email,
      type: payload.type,
      password: payload.password,
      expireable: payload.expireable,
      expiredate: payload.expiredate,
      startdate: payload.startdate,
      skills: payload.skills,
    };
    const response = await auth.middleware.post(
      "/RecycleUser",
      JSON.stringify(body),
      {
        headers: { request: "RecycleUser" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    return { success: responseData.success, message: responseData.message };
  },
  //UpdateUserValidty
  async SetUserValidty(_, payload) {
    // console.log("My payload set: ", payload);
    const body = {
      expiredate: payload.expiredate,
      enabled: payload.enabled,
      username: payload.username,
    };
    const response = await auth.middleware.post(
      "/UpdateUserValidty",
      JSON.stringify(body),
      {
        headers: { request: "UpdateUserValidty" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },
  //SetRestPeriod
  async SetRestPeriod(_, payload) {
    // console.log("My payload set: ", payload);
    const body = { period: payload.period, process: payload.process };
    const response = await auth.middleware.post(
      "/SetRestPeriod",
      JSON.stringify(body),
      {
        headers: { request: "SetRestPeriod" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetSkillInfo(context, payload) {
    // SetHeaders(context);
    const response = await auth.middleware.get(
      "/GetSkillInfo?name=" + payload,
      {
        headers: { request: "GetSkillInfo" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    if (responseData.success) {
      if (responseData.result.waitClass) {
        responseData.result.waitClass =
          responseData.result.waitClass.id == 0
            ? null
            : responseData.result.waitClass;
      }
      context.commit("setSkillInfo", responseData.result);
    }

    return { success: responseData.success, message: responseData.message };
  },
  async SetRestLimit(_, payload) {
    // console.log("My rest limit: ", payload);
    const body = { skill: payload.skill, restLimit: payload.restLimit };
    const response = await auth.middleware.post(
      "/SetSkillRestLimit",
      JSON.stringify(body),
      {
        headers: { request: "SetSkillRestLimit" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetBusyLimit(_, payload) {
    // console.log("My rest limit: ", payload);
    const body = { skill: payload.skill, busyLimit: payload.busyLimit };
    const response = await auth.middleware.post(
      "/SetSkillBusyLimit",
      JSON.stringify(body),
      {
        headers: { request: "SetSkillBusyLimit" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetForwarding(_, payload) {
    const body = { skill: payload.skill, enabled: payload.enabled };
    const response = await auth.middleware.post(
      "/SetSkillForwarding",
      JSON.stringify(body),
      {
        headers: { request: "SetSkillForwarding" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetSchedules(context) {
    // SetHeaders(context);
    const response = await auth.middleware.get("/GetSchedules", {
      headers: { request: "GetSchedules" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    if (responseData.success) {
      context.commit("setSchedules", responseData.result.schedules);
    }

    return { success: responseData.success, message: responseData.message };
  },
  async GetScheduleSkills(context, payload) {
    // SetHeaders(context);
    const response = await auth.middleware.get(
      "/GetScheduleSkills?id=" + payload,
      {
        headers: { request: "GetScheduleSkills" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    return {
      success: responseData.success,
      message: responseData.message,
      skills: responseData.result.skills,
    };
  },

  async SetSchedule(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetSchedule",
      JSON.stringify(body),
      {
        headers: { request: "SetSchedule" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    return { success: responseData.success, message: responseData.message };
  },

  async DeleteSchedule(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/DeleteSchedule",
      JSON.stringify(body),
      {
        headers: { request: "DeleteSchedule" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },

  async SetScheduleOffworkAudio(_, payload) {
    // const body = { skill: payload.skill, enabled: payload.enabled };
    let formData = new FormData();
    formData.append("file", payload.file);
    const response = await auth.middleware.post(
      "/SetScheduleOffWork",
      formData,
      {
        headers: {
          request: "SetScheduleOffWork",
          "Content-Type": "multipart/form-data",
          filename: payload.filename,
          filesize: payload.filesize,
          schedule: payload.schedule,
        },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },

  async RemoveScheduleOffWork(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/RemoveScheduleOffWork",
      JSON.stringify(body),
      {
        headers: { request: "RemoveScheduleOffWork" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },

  async SetSkillSchedule(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetSkillSchedule",
      JSON.stringify(body),
      {
        headers: { request: "SetSkillSchedule" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetWaitClasses(context) {
    // SetHeaders(context);
    const response = await auth.middleware.get("/GetWaitClasses", {
      headers: { request: "GetWaitClasses" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    if (responseData.success) {
      context.commit("setWaitClasses", responseData.result.classes);
    }

    return { success: responseData.success, message: responseData.message };
  },
  async SetWaitClass(_, payload) {
    let formData = new FormData();
    formData.append("file", payload.file);
    const response = await auth.middleware.post("/SetWaitClass", formData, {
      headers: {
        request: "SetWaitClass",
        "Content-Type": "multipart/form-data",
        filename: payload.filename,
        filesize: payload.filesize,
        class: payload.class,
        id: payload.id,
        process: payload.process,
      },
    });
    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    return { success: responseData.success, message: responseData.message };
  },

  async DeleteWaitClass(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/DeleteWaitClass",
      JSON.stringify(body),
      {
        headers: { request: "DeleteWaitClass" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },

  async SetSkillWaitClass(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetSkillWaitClass",
      JSON.stringify(body),
      {
        headers: { request: "SetSkillWaitClass" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },

  async GetDomainWelcome(context) {
    // SetHeaders(context);
    const response = await auth.middleware.get("/GetDomainWelcome", {
      headers: { request: "GetDomainWelcome" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }

    if (responseData.success && responseData.result.name !== "") {
      context.commit("setWelcomeMsg", responseData.result);
    }

    return { success: responseData.success, message: responseData.message };
  },

  async SetDomainWelcome(_, payload) {
    // const body = { skill: payload.skill, enabled: payload.enabled };
    let formData = new FormData();
    formData.append("file", payload.file);
    const response = await auth.middleware.post(
      "/SetWelcomeMessage",
      formData,
      {
        headers: {
          request: "SetWelcomeMessage",
          "Content-Type": "multipart/form-data",
          filename: payload.filename,
          filesize: payload.filesize,
          process: payload.process,
        },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },
  async RemoveDomainWelcome(context, payload) {
    const response = await auth.middleware.post(
      "/RemoveWelcomeMessage",
      JSON.stringify({ process: payload.process }),
      {
        headers: { request: "RemoveWelcomeMessage" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    if (responseData.success) {
      context.commit("setWelcomeMsg", null);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetAllDomainsInfo(context) {
    const response = await auth.middleware.get("/GetAllDomainsInfo", {
      headers: { request: "GetAllDomainsInfo" },
    });

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    if (responseData.success) {
      context.commit("setDomains", responseData.result.domains);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetCallReasons(context) {
    const response = await auth.middleware.get("/GetDomainCallReasons", {
      headers: { request: "GetDomainCallReasons" },
    });
    const responseData = response.data;
    // console.log("My data", responseData);
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    if (responseData.success) {
      // console.log("My callreasons", responseData.result.callReasons);
      context.commit("setCallReasons", responseData.result.callReasons);
    }
    return { success: responseData.success, message: responseData.message };
  },

  async CreateNewCallReason(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/CreateCallReason",
      JSON.stringify(body),
      {
        headers: { request: "CreateCallReason" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async EditCallReason(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/EditCallReason",
      JSON.stringify(body),
      {
        headers: { request: "EditCallReason" },
      }
    );

    const responseData = response.data;
    if (response.status != 200) {
      //
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetCallReasonStatus(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetCallReasonStatus",
      JSON.stringify(body),
      {
        headers: { request: "SetCallReasonStatus" },
      }
    );

    const responseData = response.data;
    if (response.status != 200) {
      //
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },
  async DeleteCallReason(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/DeleteCallReason",
      JSON.stringify(body),
      {
        headers: { request: "DeleteCallReason" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
      //   const error = new Error(responseData.message || "Failed to get users");
      //   throw error;
    }
    return { success: responseData.success, message: responseData.message };
  },

  async GetDomainInfo(context, paylaod) {
    const response = await auth.middleware.get(
      "/GetDomainInfo?name=" + paylaod,
      {
        headers: { request: "GetDomainInfo" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    if (responseData.success) {
      context.commit("setDomainInfo", responseData.result);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetSelectedDomainUsers(context, payload) {
    const response = await auth.middleware.get(
      "/GetSelectedDomainUsers?name=" + payload,
      {
        headers: { request: "GetSelectedDomainUsers" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    if (responseData.success) {
      context.commit("setDomainUsernames", responseData.result.usernames);
    }
    return {
      success: responseData.success,
      message: responseData.message,
      result: responseData.result,
    };
  },
  async GetUserTypePermissions(_, payload) {
    var params = "username=" + payload.username + "&domain=" + payload.domain;
    const response = await auth.middleware.get(
      "/GetUserTypePermissions?" + params,
      {
        headers: { request: "GetUserTypePermissions" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    return {
      success: responseData.success,
      message: responseData.message,
      result: responseData.result,
    };
  },
  async GetDomainsNames(context) {
    const response = await auth.middleware.get("/GetDomainsNames", {
      headers: { request: "GetDomainsNames" },
    });

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    if (responseData.success) {
      context.commit("setDomainsNames", responseData.result.names);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetDomainsShortCodes(context) {
    const response = await auth.middleware.get("/GetDomainsShortCodes", {
      headers: { request: "GetDomainsShortCodes" },
    });

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    if (responseData.success) {
      context.commit("setdomainsShortCodes", responseData.result.shortCodes);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetAllDomainsRanges(context) {
    const response = await auth.middleware.get("/GetAllDomainsRanges", {
      headers: { request: "GetAllDomainsRanges" },
    });

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    if (responseData.success) {
      context.commit("setDomainsRanges", responseData.result.ranges);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetDefualtDomainPermissions(context) {
    const response = await auth.middleware.get("/GetDefualtDomainPermissions", {
      headers: { request: "GetDefualtDomainPermissions" },
    });

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    if (responseData.success) {
      context.commit(
        "setDomainNonDefaultPermissions",
        responseData.result.permissions
      );
      context.commit(
        "setDefaultDominUserPermissions",
        responseData.result.userPermissions
      );
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetDefaultDomainPhoneInfo(context) {
    const response = await auth.middleware.get("/GetDefaultDomainPhoneInfo", {
      headers: { request: "GetDefaultDomainPhoneInfo" },
    });

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    if (responseData.success) {
      context.commit(
        "setDefaultDomainPhoneInfo",
        responseData.result.phoneInfo
      );
    }
    return { success: responseData.success, message: responseData.message };
  },

  async CreateNewDomain(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/CreateDomain",
      JSON.stringify(body),
      {
        headers: { request: "CreateDomain" },
      }
    );
    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },

  async GetAllDomainsSkills(context) {
    const response = await auth.middleware.get("/GetAllDomainsSkills", {
      headers: { request: "GetAllDomainsSkills" },
    });

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    if (responseData.success) {
      context.commit("setAllDomainsSkills", responseData.result.skills);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetIVRCallRatingSettings(context) {
    const response = await auth.middleware.get("/GetIVRCallRatingSettings", {
      headers: { request: "GetIVRCallRatingSettings" },
    });

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    if (responseData.success) {
      context.commit("setIvrRating", responseData.result.settings);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async CreateDomainSkill(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/CreateDomainSkill",
      JSON.stringify(body),
      {
        headers: { request: "CreateDomainSkill" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetDomainSessionURL(_, payload) {
    const body = { ...payload };

    const response = await auth.middleware.post(
      "/SetDomainSessionURL",
      JSON.stringify(body),
      {
        headers: { request: "SetDomainSessionURL" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetDomainShortCodes(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetDomainShortCodes",
      JSON.stringify(body),
      {
        headers: { request: "SetDomainShortCodes" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetDomainStatus(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetDomainStatus",
      JSON.stringify(body),
      {
        headers: { request: "SetDomainStatus" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetDomainRanges(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetDomainRanges",
      JSON.stringify(body),
      {
        headers: { request: "SetDomainRanges" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetDomainUsersLimit(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetDomainUsersLimit",
      JSON.stringify(body),
      {
        headers: { request: "SetDomainUsersLimit" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetDomainPhoneConf(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetDomainPhoneConf",
      JSON.stringify(body),
      {
        headers: { request: "SetDomainPhoneConf" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetDomainDefaultPermissions(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetDomainDefaultPermissions",
      JSON.stringify(body),
      {
        headers: { request: "SetDomainDefaultPermissions" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetUserPermissions(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetUserPermissions",
      JSON.stringify(body),
      {
        headers: { request: "SetUserPermissions" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetSkillConf(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetSkillConf",
      JSON.stringify(body),
      {
        headers: { request: "SetSkillConf" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetIVRCallRating(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetIVRCallRating",
      JSON.stringify(body),
      {
        headers: { request: "SetIVRCallRating" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },

  async UploadIVRRatingMessage(_, payload) {
    let formData = new FormData();
    formData.append("file", payload.file);
    const response = await auth.middleware.post(
      "/UploadIVRRatingMessage",
      formData,
      {
        headers: {
          request: "UploadIVRRatingMessage",
          "Content-Type": "multipart/form-data",
          filename: payload.filename,
          filesize: payload.filesize,
          ratingtype: payload.ratingAudioType,
          class: payload.class,
          id: payload.id,
          language: payload.language,
        },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  // async UploadTestImage(_, payload) {
  //   let formData = new FormData();
  //   formData.append("file", payload.file);
  //   const response = await auth.middleware.post("/UploadTestImage", formData, {
  //     headers: {
  //       request: "UploadTestImage",
  //       "Content-Type": "multipart/form-data",
  //       filename: payload.filename,
  //       filesize: payload.filesize,
  //       ratingtype: payload.ratingAudioType,
  //       class: payload.class,
  //     },
  //   });

  //   const responseData = await response.data;
  //   if (response.status !== 200) {
  //     return { success: responseData.success, message: responseData.message };
  //   }
  //   return { success: responseData.success, message: responseData.message };
  // },
  async SetACWCallSettings(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetACWCallSettings",
      JSON.stringify(body),
      {
        headers: { request: "SetACWCallSettings" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetLocalCRMFields(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetLocalCRMFields",
      JSON.stringify(body),
      {
        headers: { request: "SetLocalCRMFields" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetCRMSettings(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetCRMSettings",
      JSON.stringify(body),
      {
        headers: { request: "SetCRMSettings" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async DeleteLocalCRMFields(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/DeleteLocalCRMFields",
      JSON.stringify(body),
      {
        headers: { request: "DeleteLocalCRMFields" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetOmniConversationRatingSettings(context) {
    const response = await auth.middleware.get(
      "/GetOmniConversationRatingSettings",
      {
        headers: { request: "GetOmniConversationRatingSettings" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    if (responseData.success) {
      context.commit("setOmniRating", responseData.result.settings);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetOmniConversationRatingSettings(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetOmniConversationRatingSettings",
      JSON.stringify(body),
      {
        headers: { request: "SetOmniConversationRatingSettings" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetCallBackConfigurations(_, payload) {
    var params = "id=" + payload.id;
    const response = await auth.middleware.get(
      "/GetCallBackConfigurations?" + params,
      {
        headers: { request: "GetCallBackConfigurations" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    return {
      success: responseData.success,
      message: responseData.message,
      callbacks: responseData.result.callbacks,
    };
  },
  async SetCallbackConfigurations(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetCallbackConfigurations",
      JSON.stringify(body),
      {
        headers: { request: "SetCallbackConfigurations" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async UploadOfftimeCallbackMessage(_, payload) {
    let formData = new FormData();
    formData.append("file", payload.file);
    const response = await auth.middleware.post(
      "/UploadOfftimeCallbackMessage",
      formData,
      {
        headers: {
          request: "UploadOfftimeCallbackMessage",
          "Content-Type": "multipart/form-data",
          filename: payload.filename,
          filesize: payload.filesize,
          ratingtype: payload.ratingAudioType,
          class: payload.class,
        },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    return { success: responseData.success, message: responseData.message };
  },

  async GetKpis(context) {
    const response = await auth.middleware.get("/GetKPIConfigurations");

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    context.commit("setKpis", responseData.result.KPIs);
    return { success: responseData.success, message: responseData.message };
  },

  async UpdateKpi(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetKPIConfigurations",
      JSON.stringify(body)
    );
    const responseData = response.data;

    return { success: responseData.success, message: responseData.message };
  },

  async AddNewCSATQuestion(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/AddNewCSATQuestion",
      JSON.stringify(body)
    );
    const responseData = response.data;

    return { success: responseData.success, message: responseData.message };
  },

  async UpdateCSATQuestion(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/UpdateRatingConf",
      JSON.stringify(body)
    );
    const responseData = response.data;

    return { success: responseData.success, message: responseData.message };
  },

  async UpdateCSATQuestionsOrder(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/UpdateRatingsOrder",
      JSON.stringify(body)
    );
    const responseData = response.data;

    return { success: responseData.success, message: responseData.message };
  },

  async GetCSATQuestions(context) {
    const response = await auth.middleware.get("/GetRatingConf?type=1");

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    context.commit("setCSATQuestions", responseData.result.settings);
    return { success: responseData.success, message: responseData.message };
  },

  async AddNewStatusReason(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/SetStatusReason",
      JSON.stringify(body)
    );
    const responseData = response.data;

    return { success: responseData.success, message: responseData.message };
  },

  async GetStatusReasons(context) {
    const response = await auth.middleware.get("/GetStatusReasons");

    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }

    context.commit("setStatusReasons", responseData.result.reasons);
    return { success: responseData.success, message: responseData.message };
  },

  async SetUserActivity(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/UpdateUserValidty",
      JSON.stringify(body)
    );
    const responseData = response.data;

    return { success: responseData.success, message: responseData.message };
  },

  async DeleteUser(_, payload) {
    const body = { ...payload };
    const response = await auth.middleware.post(
      "/DeleteUser",
      JSON.stringify(body)
    );
    const responseData = response.data;

    return { success: responseData.success, message: responseData.message };
  },

  async SetUserStatusByAdmin(_, payload) {
    const request = {
      statusUser: payload.user,
      status: payload.status,
      skills: payload.skills || [],
      isAdmin: true,
    };
    if (payload.reason) {
      request.reason = payload.reason;
    }
    if (payload.period) {
      request.period = payload.period;
    }

    const response = await auth.middleware.post(
      "/SetStatus",
      JSON.stringify(request),
      {
        headers: { request: "setStatus" },
      }
    );
    const responseData = response.data;
    if (response.status !== 200) {
      if (response.status === 401) {
        // Handle unauthorized
        return { success: false, message: "Unauthorized" };
      }
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }

    return { success: responseData.success, message: responseData.message };
  },

  async GetAutoAnswerStatus(context) {
    const response = await auth.middleware.get("/GetAutoAnswerStatus", {
      headers: { request: "GetAutoAnswerStatus" },
    });
    const responseData = response.data;
    if (responseData.success) {
      context.commit("setAutoAnswer", responseData.result.is_auto, { root: true });
    }
    return { success: responseData.success, message: responseData.message };
  },

  async ToggleAutoAnswer(context, payload) {
    const request = {
      is_auto: payload.is_auto,
    };

    const response = await auth.middleware.post(
      "/ToggleAutoAnswerStatus",
      JSON.stringify(request),
      {
        headers: { request: "ToggleAutoAnswerStatus" },
      }
    );
    const responseData = response.data;
    if (response.status !== 200) {
      if (response.status === 401) {
        return { success: false, message: "Unauthorized" };
      }
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }

    if (responseData.success) {
      context.commit("setAutoAnswer", payload.is_auto, { root: true });
    }

    return { success: responseData.success, message: responseData.message };
  },

};

// function SetHeaders(context) {
//   auth.middleware.defaults.headers.common["token"] = context.getters.token;
//   auth.middleware.defaults.headers.common["domain"] = context.getters.domain;
//   auth.middleware.defaults.headers.common["uname"] = context.getters.uname;
// }
